
import { computed, defineComponent, PropType, reactive } from 'vue'

import { PlanningRecordContainer } from '@/new-services/types/planning'

// @components
import Cheap from '@/common/components/UI/Cheap/index.vue'
import NewTableActions from '@/ui-kit/NewTableActions/index.vue'
import NewTableAction from '@/ui-kit/NewTableAction/index.vue'
import NewModal from '@/common/new-components/NewModal/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'

// @icons
import iconRocket from '@/assets/icons/rocket.svg'
import { Provider } from '@/new-services/types/couriers'
import useNotifications from '@/common/composable/useNotifications'

import planningAPI from '@/new-services/planning.service'

import { formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    props: {
        column: {
            type: Object as PropType<{ name: string; key: string }>,
            required: true,
        },
        row: {
            type: Object as PropType<PlanningRecordContainer>,
            required: true,
        },
        index: {
            type: Number,
            default: 0,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
        providers: {
            type: Array as PropType<Provider[]>,
            default: () => [],
        },
        regularTable: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Cheap,
        iconRocket,
        NewTableActions,
        NewTableAction,
        NewModal,
        Loader,
        NewButton,
    },
    emits: ['toggle'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const pickup_state = reactive({
            is_loading: false,
            is_open: false,
            code: null as string | null,
        })

        const emitToggle = (row: PlanningRecordContainer) => {
            emit('toggle', row.id)
        }

        const getCourierTitle = computed(() => {
            const provider = props.providers.find((p) => p.id === props.row.fastDeliveryProviderId)
            return props.row && props.row.fastDeliveryProviderId && provider
                ? provider.name
                : 'Ракета'
        })

        const pickupCode = async (id: number) => {
            try {
                pickup_state.is_loading = true
                pickup_state.is_open = true

                const response = await planningAPI.pickupCode(id)
                pickup_state.code = response.data.pickup_code
                notifications.notify({ type: 'success', title: 'Код успешно получен' })
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'Произошла ошибка',
                })
            } finally {
                pickup_state.is_loading = false
            }
        }

        const closePickup = () => {
            pickup_state.is_loading = false
            pickup_state.is_open = false
            pickup_state.code = null
        }

        const getClass = computed(() => {
            if (props.row && props.row.status) {
                const { id } = props.row.status

                if (id === 1) return 'blue--outline'
                if (id === 2) return 'blue--fill--light'
                if (id === 3) return 'yellow--outline'
                if (id === 4) return 'yellow--fill'
                if (id === 5) return 'orange--outline'
                if (id === 6) return 'orange--fill'
                if (id === 7) return 'green--outline'
            }

            return ''
        })

        return {
            pickup_state,
            emitToggle,
            getCourierTitle,
            pickupCode,
            closePickup,
            getClass,
            formatDateWithTimeFromBackend,
        }
    },
})
